import { render } from "./GameSelection.vue?vue&type=template&id=589fa4b4&scoped=true"
import script from "./GameSelection.vue?vue&type=script&lang=js"
export * from "./GameSelection.vue?vue&type=script&lang=js"

import "./GameSelection.vue?vue&type=style&index=0&id=589fa4b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589fa4b4"]])

export default __exports__